import { configureStore } from "@reduxjs/toolkit";
import { reportBuilderSlice } from "./reducer";
import { loginDetails } from "./loginReducer";

const store = configureStore({
    reducer:{
        selectedDimensions : reportBuilderSlice.reducer,
        loginDetails: loginDetails.reducer 
     }
})

export default store;